// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"23804d34","703":"a8647fdc"}[chunkId] + ".chunk.js";
};